<template>
  <b-modal
    v-model="activRouls"
    centered
    title="تعديل العضوية"
    id="modal-rouls"
    footer-class="removed"
    cancel-variant="outline-secondary"
    size="xl"
    no-close-on-backdrop
  >
    <validation-observer ref="editRoulsValidation">
      <b-form class="auth-login-form mt-2" @submit.prevent>
        <b-card-text>
          <b-list-group class="rounded">
            <b-list-group-item class="">
              <b-row class="">
                <b-col> المسمى الوظيفي </b-col>
                <b-col
                  ><feather-icon icon="CalendarIcon" /> تاريخ بداية العضوية
                </b-col>
                <b-col
                  ><feather-icon icon="CalendarIcon" /> تاريخ نهاية العضوية
                </b-col>
                <b-col> </b-col>
              </b-row>
            </b-list-group-item>
            <div>
              <alert
                massage="عذراً لا يوجد نتائج لعرضها"
                class="w-100"
                v-if="rouls.length == 0 && !loadingRouls"
              ></alert>
            </div>
            <div
              class="text-info text-center px-5"
              style="margin: 30px"
              v-if="loadingRouls"
            >
              <b-spinner variant="info"></b-spinner> جاري التحميل...
            </div>
            <b-list-group-item v-else v-for="item in rouls" :key="item.id">
              <b-row v-if="id_rouls == item.id">
                <b-col>
                  <form-select
                    label="المسمى الوظيفي"
                    v-model="id_roul"
                    :getOptionLabel="(x) => x.name"
                    :reduce="(x) => x.id"
                    id="employee_roles"
                    ep="v2/selects/employee-roles"
                    rules="required"
                  />
                </b-col>
                <b-col>
                  <b-form-group label="تاريخ البداية" label-for="date">
                    <validation-provider
                      #default="{ errors }"
                      name="employment_date"
                      rules="required"
                    >
                      <cleave
                        id="date"
                        v-model="start_date"
                        class="form-control"
                        :raw="false"
                        :options="options.date"
                        placeholder="YYYY-MM-DD"
                        :class="{ 'cleave-error': errors.length > 0 }"
                      />
                      <small class="text-danger">{{
                        errors[0] ? "الحقل مطلوب" : ""
                      }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="تاريخ النهاية" label-for="date">
                    <cleave
                      id="date"
                      v-model="end_date"
                      class="form-control"
                      :raw="false"
                      :options="options.date"
                      placeholder="YYYY-MM-DD"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  class="justify-content-end d-flex pt-50 align-items-center"
                >
                  <b-button
                    @click="id_rouls = null"
                    variant="outline-secondary"
                    class=""
                  >
                    <feather-icon icon="XIcon" />
                    إلغاء
                  </b-button>
                  <save-btn
                    :loading="upDateLoading"
                    @click="formSubmitEdit(item.id)"
                    class="ml-1"
                    variant="primary"
                    style="height: 40px"
                    type="submit"
                  >
                  </save-btn>
                </b-col>
              </b-row>

              <b-row class="align-items-center" v-else>
                <b-col>{{ item.employeeRole.name }}</b-col>
                <b-col> {{ item.start_date }} </b-col>
                <b-col> {{ item.end_date }}</b-col>
                <b-col class="justify-content-end d-flex">
                  <b-button
                    @click="
                      id_rouls = item.id;
                      start_date = item.start_date;
                      end_date = item.end_date;
                      id_roul = item.employeeRole.id;
                      isAdding = false;
                    "
                    variant="flat-primary"
                    class="btn-icon rounded-circle"
                  >
                    <feather-icon icon="EditIcon" />
                  </b-button>
                  <b-spinner
                    v-if="deleteLoading == item.id"
                    small
                    variant="danger"
                    class="mt-1"
                    style="margin-left: 12px; margin-right: 12px"
                  ></b-spinner>
                  <b-button
                    v-else
                    @click="
                      deleteLoading = item.id;
                      deletRouls({
                        id: item.id,
                        employee_id: id_employee,
                      }).then(() => {
                        deleteLoading = null;
                      });
                    "
                    variant="flat-danger"
                    class="btn-icon rounded-circle"
                  >
                    <feather-icon icon="Trash2Icon" />
                  </b-button>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item v-if="isAdding">
              <h5 class="mb-2 text-primary">إضافة عضوية </h5>
              <b-row>
                <b-col>
                  <form-select
                    label="المسمى الوظيفي"
                    v-model="id_roul"
                    :getOptionLabel="(x) => x.name"
                    :reduce="(x) => x.id"
                    id="employee_roles"
                    ep="v2/selects/employee-roles"
                    rules="required"
                  />
                </b-col>
                <b-col>
                  <b-form-group label="تاريخ البداية" label-for="date">
                    <validation-provider
                      #default="{ errors }"
                      name="employment_date"
                      rules="required"
                    >
                      <cleave
                        id="date"
                        v-model="start_date"
                        class="form-control"
                        :raw="false"
                        :options="options.date"
                        placeholder="YYYY-MM-DD"
                        :class="{ 'cleave-error': errors.length > 0 }"
                      />
                      <small class="text-danger">{{
                        errors[0] ? "الحقل مطلوب" : ""
                      }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="تاريخ النهاية" label-for="date">
                    <cleave
                      id="date"
                      v-model="end_date"
                      class="form-control"
                      :raw="false"
                      :options="options.date"
                      placeholder="YYYY-MM-DD"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  class="justify-content-end d-flex pt-50 align-items-center"
                >
                  <b-button
                    @click="isAdding = false"
                    variant="outline-secondary"
                    class=""
                  >
                    <feather-icon icon="XIcon" />
                    إلغاء
                  </b-button>
                  <save-btn
                    :loading="creaateLoading"
                    class="ml-1"
                    variant="primary"
                    style="height: 40px"
                    @click="formSubmitCreate()"
                    type="submit"
                  >
                  </save-btn>
                </b-col>
              </b-row>
            </b-list-group-item>
          </b-list-group>
        </b-card-text>

        <b-row class="px-1 d-flex justify-content-end">
          <b-button @click="unFilter()" variant="success">
            <feather-icon icon="PlusIcon" />
            <span> إضافة </span>
          </b-button>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
<script>
import FormSelect from "@/components/form-select";
import saveBtn from "@/components/loader-btn";
import {
  BModal,
  BForm,
  BButton,
  BFormGroup,
  BCol,
  BRow,
  BCardText,
  BListGroup,
  BListGroupItem,
  BSpinner,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Cleave from "vue-cleave-component";
import "cleave.js/dist/addons/cleave-phone.us";
import { mapActions, mapGetters } from "vuex";
import Alert from "@/components/Alert.vue";
export default {
  props: {
    value: Boolean,
    id_employee: Number,
  },
  components: {
    BSpinner,
    BListGroupItem,
    BListGroup,
    BModal,
    FormSelect,
    BForm,
    ValidationProvider,
    ValidationObserver,
    BButton,
    BFormGroup,
    Cleave,
    BCol,
    BRow,
    BCardText,
    saveBtn,
    Alert,
  },
  data: () => {
    return {
      isAdding: false,
      deleteLoading: false,
      id_rouls: null,
      id_roul: null,
      start_date: "",
      end_date: "",

      options: {
        date: {
          date: true,
          delimiter: "-",
          datePattern: ["Y", "m", "d"],
        },
      },
    };
  },
  methods: {
    formSubmitEdit(id) {
      this.$refs.editRoulsValidation.validate().then(async (success) => {
        if (success) {
          this.editRouls(id);
        }
      });
    },

    formSubmitCreate() {
      this.$refs.editRoulsValidation.validate().then(async (success) => {
        if (success) {
          this.addRouls();
        }
      });
    },
    ...mapActions("AdministrativeStatus/Employees", [
      "getRouls",
      "upDateRouls",
      "createRouls",
      "deletRouls",
    ]),
    editRouls(id) {
      this.upDateRouls({
        id: id,
        data: {
          start_date: this.start_date,
          end_date: this.end_date,
          employee_id: this.id_employee,
          employee_role_id: this.id_roul,
        },
      }).then(() => {
        this.id_rouls = null;
      });
    },
    addRouls() {
      this.createRouls({
        data: {
          start_date: this.start_date,
          end_date: this.end_date,
          employee_id: this.id_employee,
          employee_role_id: this.id_roul,
        },
      }).then(() => {
        this.isAdding = false;
      });
    },
    unFilter() {
      this.id_roul = null;
      this.start_date = "";
      this.end_date = "";
      this.isAdding = true;
      id_rouls = null;
    },
    // deleteRoul(id) {
    //   this.deletRouls({
    //     data: {
    //       employee_id: this.id_employee,
    //       employee_role_id: id,
    //     },
    //   });
    // },
  },
  watch: {
    id_employee(val) {
      this.getRouls({ id: val });
    },
  },

  computed: {
    ...mapGetters("AdministrativeStatus/Employees", [
      "rouls",
      "loadingRouls",
      "upDateLoading",
      "creaateLoading",
    ]),
    activRouls: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  created() {
    // if(id_employee)
    // this.getRouls({id:this.id_employee})
  },
};
</script>

<style scoped>
</style>